import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['form', 'selectedSubscription']
  static values = {
    upgrade: Boolean
  }

  removeQueryParams() {
    removeQueryParams()
  }

  openReasonModal(event) {
    event.preventDefault()
    const form = this.formTarget
    const currentSubscriptionCount = Number(this.selectedSubscriptionTarget.dataset.selected)
    const selectedCount = Number(this.selectedSubscriptionTarget.value)

    if (selectedCount < currentSubscriptionCount) {
      $('#manage-subscription-modal-content').hide()
      $('#downgrade-reason-modal-content').show()
    } else {
      form.submit()
    }
  }

}
